import { AboutUsModel } from "../entities/AboutUsModel";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}company-description`;
const API_URL_ABOUT_US = `${process.env.REACT_APP_API_URL}about-us`;

export const fetchAboutUs = async (): Promise<AboutUsModel[]> => {
  const response = await axios.get(API_URL_ABOUT_US); // Use axios to make the GET request.
  const data = response.data.data; // Access the nested 'data' array.
  
  // Map the response to BenefitProducts instances.
  return data.map((item: any) => new AboutUsModel(item.id, item.title, item.description, item.image));
};

export const fetchCompanyDesc = async (): Promise<AboutUsModel[]> => {
    const response = await axios.get(API_URL); // Use axios to make the GET request.
    const data = response.data.data; // Access the nested 'data' array.
    
    // Map the response to BenefitProducts instances.
    return data.map((item: any) => new AboutUsModel(item.id, item.title, item.description, item.image));
  };